// extracted by mini-css-extract-plugin
export var productImage = "_n1-1";
export var viewLink = "_n1-2";
export var wishlistItem = "_n1-0";